import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { logger } from "@/lib/logger";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return undefined;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/auth?mode=login", { replace: true });
      return undefined;
    }
    const role = sessionStorage.getItem("oauth_role") || "customer";
    sessionStorage.removeItem("oauth_role");

    let cancelled = false;
    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sessionId, role });
        if (cancelled) return;
        await refresh();
        const u = r.data.user;
        const dest = u?.role === "admin" ? "/admin" : u?.role === "contractor" ? "/contractor" : "/customer";
        navigate(dest, { replace: true, state: { user: u } });
      } catch (err) {
        if (cancelled) return;
        logger.error("[auth] google session failed", err);
        toast.error("Google sign-in failed");
        navigate("/auth?mode=login", { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bone">
      <div className="font-mono uppercase tracking-widest text-xs">Signing you in…</div>
    </div>
  );
}
